import React, { useEffect, useState } from "react";
import { Modal, Box, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Button } from "@mui/material";
import { svUpdateWaterBill } from "../../../services/expenses/waterbill.service";
import CancelIcon from "@mui/icons-material/Cancel";
import SwalUI from "../../../components/ui/swal-ui/swal-ui";
import "./FormAddmodal.scss";
import moment from "moment";

function FormEditmodal(props) {
  const { setRefreshData, openEdit, setOpenEdot, waterBillEdit } = props;
  const [selectedStartDate, setSelectedStartDate] = useState(moment());
  const [editData, setEditData] = useState(waterBillEdit);
  const [isError, setIsError] = useState({
    uses_quantity: false,
    numbeunit_old: false,
    numbeunit_new: false,
    price_unit: false,
  });

  useEffect(() => {
    let p = editData.current - editData.last_time;
    setEditData((prevState) => ({
      ...prevState,
      quantity: p,
    }));
  }, [editData.current, editData.last_time]);

  const editValidators = () => {
    let isValid = true;

    let error = {
      ...isError,
      uses_quantity: editData.quantity < 1,
      numbeunit_old: editData.last_time < 1,
      numbeunit_new: editData.current < 1,
      price_unit: editData.expenses < 1,
    };
    setIsError(() => error);

    const hasError = Object.values(error).find((err) => err === true);
    if (hasError) isValid = false;
    if (isValid) {
      const formData = new FormData();
      formData.append("id_waterBill", editData.id);
      formData.append(
        "edit_date",
        typeof editData.date === "string"
          ? editData.date
          : moment(editData.date).format("DD/MM/YYYY")
      );
      formData.append("uses_quantity", editData.quantity);
      formData.append("numbeunit_old", editData.last_time);
      formData.append("numbeunit_new", editData.current);
      formData.append("price_unit", editData.expenses);

      /* Display the key/value pairs*/
      for (var pair of formData.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }
      //   return false;
      svUpdateWaterBill(formData).then((res) => {
        console.log(res);
        if (res.status === 200) {
          setRefreshData((prev) => prev + 1);
          SwalUI({
            status: res.data.status,
            // //description: res.data.description
          });
          setOpenEdot(false);
        }
      });
    }
  };

  return (
    <Modal
      open={openEdit}
      onClose={() => {
        setOpenEdot(false);
      }}
    >
      <Box
        className="width-modal"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "white",
          borderRadius: "10px",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          p: 4,
        }}
      >
        <div className="box-modal-add">
          <div className="justifu-CancelIcon">
            <p
              style={{
                fontSize: "1.75rem",
                fontWeight: 500,
                alignItems: "center",
              }}
            >
              ข้อมูลค่าน้ำ
            </p>
            <button
              onClick={() => {
                setOpenEdot(false);
              }}
            >
              <CancelIcon className="CancelIcon" />
            </button>
          </div>

          <div className="main-modal">
            <div className="box-modal-1">
              <div className="box-maintenance">
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  วันที่เรียกเก็บ
                </p>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    // label="ปี"
                    inputFormat="DD / MM / YYYY"
                    value={moment(editData.date, "DD / MM / YYYY")}
                    onChange={(datemoment) => {
                      //   console.log(datemoment);s
                      setEditData((prevState) => ({
                        ...prevState,
                        date: moment(datemoment, "DD / MM / YYYY"),
                      }));
                    }}
                    sx={{ width: "33.33%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{ width: "100%" }}
                        size="small"
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true,
                        }}
                        required
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
              <div className="box-section">
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  เลขครั้งก่อน
                </p>
                <TextField
                  id="outlined-basic"
                  value={editData.last_time}
                  size="small"
                  // label="หัวข้อ"
                  InputProps={{
                    inputProps: {
                      pattern: "[0-9]", // Regular expression allowing only numbers
                    },
                  }}
                  onInput={(event) => {
                    const { value } = event.target;
                    const newValue = value.replace(/[^0-9]/g, ""); // Replace non-numeric characters with empty string
                    event.target.value = newValue; // Set the new value
                  }}
                  variant="outlined"
                  style={{ width: "100%" }}
                  error={isError.numbeunit_old}
                  onChange={(e) =>
                    setEditData((prevState) => {
                      return { ...prevState, last_time: e.target.value };
                    })
                  }
                />
              </div>
              <div className="box-section">
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  ยอดค่าใช้จ่าย
                </p>
                <TextField
                  id="outlined-basic"
                  value={editData.expenses}
                  size="small"
                  // label="หัวข้อ"
                  InputProps={{
                    inputProps: {
                      pattern: "[0-9]", // Regular expression allowing only numbers
                    },
                  }}
                  onInput={(event) => {
                    const { value } = event.target;
                    const newValue = value.replace(/[^0-9]/g, ""); // Replace non-numeric characters with empty string
                    event.target.value = newValue; // Set the new value
                  }}
                  variant="outlined"
                  style={{ width: "100%" }}
                  error={isError.price_unit}
                  onChange={(e) =>
                    setEditData((prevState) => {
                      return { ...prevState, expenses: e.target.value };
                    })
                  }
                />
              </div>
            </div>
            <div className="box-modal-2">
              <div className="box-name-person">
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  จำนวนที่ใช้
                </p>
                <TextField
                  id="outlined-basic"
                  value={editData.quantity}
                  size="small"
                  // label="หัวข้อ"
                  // defaultValue="100"
                  variant="outlined"
                  disabled
                  style={{ width: "100%", backgroundColor: "#f3f4f6" }}
                  error={isError.uses_quantity}
                />
              </div>
              <div className="box-name-person">
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: "16px",
                    marginBottom: "5px",
                  }}
                >
                  เลขครั้งหลัง
                </p>
                <TextField
                  id="outlined-basic"
                  value={editData.current}
                  size="small"
                  // label="หัวข้อ"
                  InputProps={{
                    inputProps: {
                      pattern: "[0-9]", // Regular expression allowing only numbers
                    },
                  }}
                  onInput={(event) => {
                    const { value } = event.target;
                    const newValue = value.replace(/[^0-9]/g, ""); // Replace non-numeric characters with empty string
                    event.target.value = newValue; // Set the new value
                  }}
                  variant="outlined"
                  style={{ width: "100%" }}
                  error={isError.numbeunit_new}
                  onChange={(e) =>
                    setEditData((prevState) => {
                      return { ...prevState, current: e.target.value };
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="Button-save">
          <Button
            variant="contained"
            size="small"
            style={{
              fontSize: "14px",
              background: "#6C5DD3",
              color: "white",
              height: "39px",
              paddingLeft: "1.5rem",
              paddingRight: "1.5rem",
            }}
            className="button-h"
            onClick={editValidators}
          >
            บันทึก
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

export default FormEditmodal;
